import axios from 'axios';
import {facebookConfig} from "../../firebase/client-app";

const accessToken = facebookConfig.accessToken;

const api = axios.create({
    baseURL: facebookConfig.graphApiBaseUri,
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
});

export default api;
